import { adminRoleType, AppState, CompanyRole, NoAdminRole, PortalAdmin, SiteAdminRole, LocationAdmin } from "../AppState"

function isAdminRole(roleSearchFor: adminRoleType, state?: AppState): boolean{
    return state?.Workforce1State.role == roleSearchFor;
}

export function isSiteAdmin(state?: AppState): boolean{
    return isAdminRole(SiteAdminRole, state);
}
//in workforce 1 this was called, isClient
export function isCompanyAdmin(state?: AppState): boolean{
    return isAdminRole(CompanyRole, state);
}
//in workforce 1 this was called, isClinic
export function isPortalAdmin(state?: AppState): boolean{
    return isAdminRole(PortalAdmin, state);
}

export function isLocationAdmin(state?: AppState): boolean {
  return isAdminRole(LocationAdmin, state)
}

// honestly, using this is bad practice, I added this function though upon request from Kyle on 6/7 made via web-x..
// but truthfully my understanding of this field alarms me A LOT, but I made my concerns known to kyle..
export function isUser(state?: AppState): boolean{
    return isAdminRole(NoAdminRole, state);
}
